import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Phone, MapPin, Lock, Camera, Save, Package, Heart, LogOut, Edit2, Plus, Trash2 } from 'lucide-react';
import Header from './components/Header8';
import Footer from './components/Footer8';

import { devLog } from '../../../utils/devLog';

const Profile8 = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('profile');
    const [isEditing, setIsEditing] = useState(false);
    const [profileData, setProfileData] = useState({
        fullName: 'Priya Sharma', email: 'priya.sharma@example.com', phone: '+91 98765 43210',
        avatar: 'https://ui-avatars.com/api/?name=Priya+Sharma&size=200&background=BE185D&color=FFFFFF&font-size=0.4',
        address: { street: '12 C-Scheme', city: 'Jaipur', state: 'Rajasthan', pincode: '302001' },
        bio: 'Lover of handcrafted Indian fashion and floral elegance.',
    });

    const [addresses, setAddresses] = useState([
        { id: 1, label: 'Home', name: 'Priya Sharma', street: '12 C-Scheme, Jaipur', city: 'Jaipur', state: 'Rajasthan', pincode: '302001', phone: '+91 98765 43210', isDefault: true },
        { id: 2, label: 'Office', name: 'Priya Sharma', street: '45 Malviya Nagar', city: 'Jaipur', state: 'Rajasthan', pincode: '302017', phone: '+91 98765 43210', isDefault: false },
    ]);

    const [passwordData, setPasswordData] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setProfileData(prev => ({ ...prev, [parent]: { ...prev[parent], [child]: value } }));
        } else {
            setProfileData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData(prev => ({ ...prev, [name]: value }));
    };

    const tabs = [
        { id: 'profile', label: 'Profile', icon: User },
        { id: 'addresses', label: 'Addresses', icon: MapPin },
        { id: 'orders', label: 'Orders', icon: Package },
        { id: 'security', label: 'Security', icon: Lock },
    ];

    const inputStyle = {
        width: '100%', padding: '12px 16px', backgroundColor: '#FDF2F8', border: '1px solid #F9A8D4', borderRadius: '8px',
        color: '#1A1A1A', fontSize: '14px', fontFamily: "'DM Sans', sans-serif", outline: 'none',
    };

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=DM+Sans:wght@300;400;500;700&display=swap');`}</style>
            <div style={{ fontFamily: "'DM Sans', sans-serif" }} className="min-h-screen bg-white">
                <Header />
                <main className="pt-24 pb-16 px-4 lg:px-8">
                    <div className="max-w-[1100px] mx-auto">
                        <h1 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-3xl lg:text-4xl font-bold mb-8">My Account</h1>

                        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                            {/* Sidebar */}
                            <div className="lg:col-span-1">
                                <div className="text-center mb-6 p-6 rounded-xl" style={{ backgroundColor: '#FDF2F8' }}>
                                    <div className="w-20 h-20 rounded-full mx-auto mb-3 overflow-hidden" style={{ border: '3px solid #BE185D' }}>
                                        <img src={profileData.avatar} alt="" className="w-full h-full object-cover" />
                                    </div>
                                    <h3 className="text-base font-bold">{profileData.fullName}</h3>
                                    <p className="text-xs" style={{ color: '#6B7280' }}>{profileData.email}</p>
                                </div>
                                <nav className="space-y-1">
                                    {tabs.map((tab) => (
                                        <button key={tab.id} onClick={() => setActiveTab(tab.id)} className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all text-left"
                                            style={{ backgroundColor: activeTab === tab.id ? '#FDF2F8' : 'transparent', color: activeTab === tab.id ? '#BE185D' : '#6B7280', border: activeTab === tab.id ? '1px solid #F9A8D4' : '1px solid transparent' }}
                                        >
                                            <tab.icon size={18} /> {tab.label}
                                        </button>
                                    ))}
                                    <button onClick={() => navigate('/template8/login')} className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-left" style={{ color: '#6B7280' }}>
                                        <LogOut size={18} /> Sign Out
                                    </button>
                                </nav>
                            </div>

                            {/* Content */}
                            <div className="lg:col-span-3">
                                {activeTab === 'profile' && (
                                    <div className="p-6 rounded-xl" style={{ backgroundColor: '#FDF2F8', border: '1px solid #F9A8D4' }}>
                                        <div className="flex items-center justify-between mb-6">
                                            <h2 className="text-lg font-bold" style={{ fontFamily: "'Libre Baskerville', serif" }}>Personal Information</h2>
                                            <button onClick={() => setIsEditing(!isEditing)} className="flex items-center gap-1 text-sm font-medium" style={{ color: '#BE185D' }}>
                                                <Edit2 size={14} /> {isEditing ? 'Cancel' : 'Edit'}
                                            </button>
                                        </div>
                                        <div className="space-y-4">
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                <div><label className="text-xs font-semibold mb-1 block" style={{ color: '#6B7280' }}>Full Name</label><input name="fullName" value={profileData.fullName} onChange={handleInputChange} disabled={!isEditing} style={{ ...inputStyle, opacity: isEditing ? 1 : 0.7 }} /></div>
                                                <div><label className="text-xs font-semibold mb-1 block" style={{ color: '#6B7280' }}>Email</label><input name="email" value={profileData.email} onChange={handleInputChange} disabled={!isEditing} style={{ ...inputStyle, opacity: isEditing ? 1 : 0.7 }} /></div>
                                            </div>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                <div><label className="text-xs font-semibold mb-1 block" style={{ color: '#6B7280' }}>Phone</label><input name="phone" value={profileData.phone} onChange={handleInputChange} disabled={!isEditing} style={{ ...inputStyle, opacity: isEditing ? 1 : 0.7 }} /></div>
                                                <div><label className="text-xs font-semibold mb-1 block" style={{ color: '#6B7280' }}>Bio</label><input name="bio" value={profileData.bio} onChange={handleInputChange} disabled={!isEditing} style={{ ...inputStyle, opacity: isEditing ? 1 : 0.7 }} /></div>
                                            </div>
                                            {isEditing && (
                                                <button className="flex items-center gap-2 px-6 py-3 rounded-lg text-sm font-semibold uppercase tracking-wider mt-4" style={{ backgroundColor: '#BE185D', color: '#FFFFFF' }} onClick={() => setIsEditing(false)}>
                                                    <Save size={16} /> Save Changes
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'addresses' && (
                                    <div className="space-y-4">
                                        {addresses.map((addr) => (
                                            <div key={addr.id} className="p-4 rounded-xl flex items-start justify-between" style={{ backgroundColor: '#FDF2F8', border: `1px solid ${addr.isDefault ? '#BE185D' : '#F9A8D4'}` }}>
                                                <div>
                                                    <div className="flex items-center gap-2 mb-1">
                                                        <span className="text-sm font-bold">{addr.label}</span>
                                                        {addr.isDefault && <span className="px-2 py-0.5 rounded-full text-[10px] font-bold" style={{ backgroundColor: '#F9A8D4', color: '#9D174D' }}>DEFAULT</span>}
                                                    </div>
                                                    <p className="text-sm" style={{ color: '#6B7280' }}>{addr.name}</p>
                                                    <p className="text-sm" style={{ color: '#6B7280' }}>{addr.street}, {addr.city}, {addr.state} - {addr.pincode}</p>
                                                    <p className="text-sm" style={{ color: '#6B7280' }}>{addr.phone}</p>
                                                </div>
                                                <button style={{ color: '#6B7280' }}><Trash2 size={16} /></button>
                                            </div>
                                        ))}
                                        <button className="w-full flex items-center justify-center gap-2 py-3 rounded-lg text-sm font-medium" style={{ border: '2px dashed #F9A8D4', color: '#BE185D' }}>
                                            <Plus size={16} /> Add New Address
                                        </button>
                                    </div>
                                )}

                                {activeTab === 'orders' && (
                                    <div className="text-center py-12 rounded-xl" style={{ backgroundColor: '#FDF2F8' }}>
                                        <Package size={40} className="mx-auto mb-4" style={{ color: '#F9A8D4' }} />
                                        <h3 className="text-lg font-bold mb-2">View Your Orders</h3>
                                        <p className="text-sm mb-4" style={{ color: '#6B7280' }}>Track deliveries and manage your order history</p>
                                        <button onClick={() => navigate('/template8/orders')} className="px-6 py-3 rounded-lg text-sm font-semibold" style={{ backgroundColor: '#BE185D', color: '#FFFFFF' }}>View Orders</button>
                                    </div>
                                )}

                                {activeTab === 'security' && (
                                    <div className="p-6 rounded-xl" style={{ backgroundColor: '#FDF2F8', border: '1px solid #F9A8D4' }}>
                                        <h2 className="text-lg font-bold mb-6" style={{ fontFamily: "'Libre Baskerville', serif" }}>Change Password</h2>
                                        <div className="space-y-4 max-w-md">
                                            <div><label className="text-xs font-semibold mb-1 block" style={{ color: '#6B7280' }}>Current Password</label><input type="password" name="currentPassword" value={passwordData.currentPassword} onChange={handlePasswordChange} style={inputStyle} /></div>
                                            <div><label className="text-xs font-semibold mb-1 block" style={{ color: '#6B7280' }}>New Password</label><input type="password" name="newPassword" value={passwordData.newPassword} onChange={handlePasswordChange} style={inputStyle} /></div>
                                            <div><label className="text-xs font-semibold mb-1 block" style={{ color: '#6B7280' }}>Confirm Password</label><input type="password" name="confirmPassword" value={passwordData.confirmPassword} onChange={handlePasswordChange} style={inputStyle} /></div>
                                            <button className="flex items-center gap-2 px-6 py-3 rounded-lg text-sm font-semibold uppercase tracking-wider" style={{ backgroundColor: '#BE185D', color: '#FFFFFF' }}>
                                                <Lock size={16} /> Update Password
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Profile8;
